import { z } from 'zod';
import { baseComponentSchema } from '../component-base.schemas';

export const shareTokenSchema = z.string().regex(/^$|^[a-f0-9]{32}$/i, 'Invalid Studio form token');

export const competeFormDataSchema = z.object({
  shareToken: shareTokenSchema,
  formName: z.string().max(200).default(''),
  desktopHeight: z.number().int().min(200).max(5000).default(640),
  mobileHeight: z.number().int().min(200).max(5000).default(800),
});

export const competeFormComponentSchema = baseComponentSchema.extend({
  type: z.literal('compete-form'),
  data: competeFormDataSchema,
});

export type CompeteFormData = z.infer<typeof competeFormDataSchema>;
export type CompeteFormComponent = z.infer<typeof competeFormComponentSchema>;
